var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 175,
    viewBox: "0 0 187 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_268_55510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7777 163.731C23.3526 163.731 26.2506 160.812 26.2506 157.211C26.2506 153.61 23.3526 150.691 19.7777 150.691C16.2027 150.691 13.3047 153.61 13.3047 157.211C13.3047 160.812 16.2027 163.731 19.7777 163.731Z",
    fill: "#34B715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.198 175.001C42.5466 175.001 44.4506 173.083 44.4506 170.717C44.4506 168.351 42.5466 166.434 40.198 166.434C37.8493 166.434 35.9453 168.351 35.9453 170.717C35.9453 173.083 37.8493 175.001 40.198 175.001Z",
    fill: "#34B715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60727 39.0603C10.2564 39.0603 13.2145 36.0807 13.2145 32.4052C13.2145 28.7296 10.2564 25.75 6.60727 25.75C2.95817 25.75 0 28.7296 0 32.4052C0 36.0807 2.95817 39.0603 6.60727 39.0603Z",
    fill: "#34B715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6565 20.3023C24.0793 20.3023 26.0434 18.324 26.0434 15.8836C26.0434 13.4432 24.0793 11.4648 21.6565 11.4648C19.2336 11.4648 17.2695 13.4432 17.2695 15.8836C17.2695 18.324 19.2336 20.3023 21.6565 20.3023Z",
    fill: "#34B715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.735 36.1987C184.642 36.1987 186.999 33.8247 186.999 30.8962C186.999 27.9678 184.642 25.5938 181.735 25.5938C178.828 25.5938 176.471 27.9678 176.471 30.8962C176.471 33.8247 178.828 36.1987 181.735 36.1987Z",
    fill: "#34B715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.334 14.6831C177.17 11.827 177.17 7.19643 174.334 4.34037C171.499 1.48432 166.901 1.48432 164.066 4.34037C161.23 7.19643 161.23 11.827 164.066 14.6831C166.901 17.5391 171.499 17.5391 174.334 14.6831Z",
    fill: "#34B715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.374 146.872C179.885 145.35 179.885 142.884 178.374 141.363C176.864 139.841 174.415 139.841 172.905 141.363C171.394 142.884 171.394 145.35 172.905 146.872C174.415 148.393 176.864 148.393 178.374 146.872Z",
    fill: "#34B715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.468 169.025C157.803 166.673 157.803 162.859 155.468 160.506C153.132 158.154 149.346 158.154 147.01 160.506C144.675 162.859 144.675 166.673 147.01 169.025C149.346 171.378 153.132 171.378 155.468 169.025Z",
    fill: "#34B715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.947 129.22C186.723 127.431 186.723 124.53 184.947 122.741C183.171 120.952 180.291 120.952 178.515 122.741C176.739 124.53 176.739 127.431 178.515 129.22C180.291 131.009 183.171 131.009 184.947 129.22Z",
    fill: "#34B715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.374 167.768C140.368 167.768 177.654 130.212 177.654 83.8839C177.654 37.5561 140.368 0 94.374 0C48.3796 0 11.0938 37.5561 11.0938 83.8839C11.0938 130.212 48.3796 167.768 94.374 167.768Z",
    fill: "#34B715"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_268_55510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.3741 150.686C131.004 150.686 160.698 120.777 160.698 83.8822C160.698 46.9873 131.004 17.0781 94.3741 17.0781C57.7448 17.0781 28.0508 46.9873 28.0508 83.8822C28.0508 120.777 57.7448 150.686 94.3741 150.686Z",
    fill: "#FFF8EE"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_268_55510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.073 61.4657C124.68 58.0479 119.174 58.0479 115.781 61.4657L85.0009 92.469L75.0989 82.4952C71.7505 79.1226 66.2982 78.9152 62.8513 82.1977C59.2791 85.5974 59.2254 91.2696 62.6723 94.7505L77.8117 110C81.7778 113.995 88.206 113.995 92.1722 110L97.2843 104.85L128.065 73.8471C131.476 70.4294 131.476 64.8834 128.073 61.4657Z",
    fill: "#34B715"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_268_55510",
    x: 13.0508,
    y: 2.07812,
    width: 162.646,
    height: 163.609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_268_55510"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_268_55510",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_268_55510",
    x: 60.1289,
    y: 58.9023,
    width: 70.4941,
    height: 58.0938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_268_55510"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_268_55510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 175,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.9d74e773221c2858bf59283875add450.svg";
export { ForwardRef as ReactComponent };